module.exports = __webpack_public_path__ + "img/90.24f4db93.png";